export default __webpack_public_path__ + "static/media/collage.531ff262.gif";